import { useEffect, useState, useRef } from "react"

import styles from "../../../assets/stylesheets/sass/Filter.module.scss"

import eye from "../../../assets/icons/eye.svg";
import eye_off from "../../../assets/icons/eye_off.svg";

export default function Radiobutton({system, data, returnedArray, placeholder="Toon alles"}){
    const [selectedValue, setSelectedValue] = useState("all")
    //const runnedCache = useRef(false)

    // useEffect(()=>{
    //     if(data.length > 0 && !runnedCache.current){
    //         console.log("set filter cache")
    //         console.log(data);
    //         if(window.localStorage.getItem(`rad${system.selector}`)){
    //             let cacheFilter = JSON.parse(window.localStorage.getItem(`rad${system.selector}`))
    //             if(cacheFilter.value){
    //                 runnedCache.current = true;
    //                 filterData(cacheFilter.value)
    //             }
    //         }
    //     }
        
    // }, [data])

    const filterData = (v) => {
        // let cacheFilter = {
        //     type: system.type,
        //     selector: system.selector,
        //     value: v
        // }

        // window.localStorage.setItem(`rad${cacheFilter.selector}`, JSON.stringify(cacheFilter))
        //console.log(cacheFilter);

        console.log(v)

        setSelectedValue(v)

        let tmp_data = [];

        for (let i = 0; i < data.length; i++) {
            if(system.options[v]){
                if(system.options[v].includes(";")){
                    let opt = system.options[v].split(";")
                    if(opt.includes(data[i][system.selector].toString())){
                        tmp_data = tmp_data.concat(data[i])
                    }
                }
            }
            else{      
                if(data[i][system.selector].toString() === system.options[v]){
                    tmp_data = tmp_data.concat(data[i])
                }
            }
        }

        returnedArray(tmp_data);
    }

    return(
        <>
        <button className={styles.backbutton} onClick={()=>{setSelectedValue("all"); returnedArray(data)}}>{placeholder}</button>
        <div className={styles.rb_options}>
            {Object.keys(system.options).map((v, i)=>{
                return (
                    <button className={styles.rb_button} onClick={()=>{filterData(v)}} key={i}>
                        <img src={(selectedValue === v || selectedValue === "all") ? eye : eye_off} alt="eye"/>
                        {v}
                    </button>
                )
            })}
        </div>
        </>
    )
}